/**
 * Redux thunk action creators.
 * These may call facades. Prefer createAsyncThunk.
 */

import { createAsyncThunk, SerializedError } from '@reduxjs/toolkit';
import { ApiFacade } from '../facades/apiFacade';
import { Entity } from '../../@types/entityCatalog';
import type { ThunkAPI } from '../stores/store';

export type FetchExampleArgs = {
    url?: string;
    accessToken?: string;
};

export const fetchEntityCatalog = createAsyncThunk<Entity, FetchExampleArgs, ThunkAPI>(
    'app/fetchEntityCatalog',
    async (args: FetchExampleArgs, thunkApi) => {
        const url = args.url ?? '/api/example';

        try {
            const data = await ApiFacade.getJson<Entity>(url, { accessToken: args.accessToken });
            return data;
        } catch (error) {
            // Keep rejected payload structured for reducers.
            return thunkApi.rejectWithValue(error as SerializedError);
        }
    }
);
